<ol
  class="items-center w-full space-y-4 sm:flex sm:space-x-8 sm:space-y-0 rtl:space-x-reverse steps-container"
  [ngClass]="{ 'steps-container--full-width': fullWidth, 'steps-container--show-line': showLine }"
>
  @for (step of steps; track $index) {
    <li
      class="flex items-center text-gray-600 dark:text-gray-500 space-x-2.5 rtl:space-x-reverse step"
      [ngClass]="{
        'text-system-600 dark:text-system-500 step--current-step': currentStep === $index + 1 || step.completed,
        'step--show-line': showLine,
      }"
      [ngStyle]="{ cursor: step.completed ? 'pointer' : 'default' }"
      (click)="goToStep($index + 1)"
    >
      <span
        class="flex items-center justify-center w-8 h-8 border border-gray-500 rounded-full shrink-0 dark:border-gray-400"
        [ngClass]="{ 'border-system-600 dark:border-system-500': currentStep === $index + 1 }"
        *ngIf="!step.completed || currentStep === $index + 1"
      >
        {{ $index + 1 }}
      </span>
      <img
        class="w-8 h-8 dark:filter dark:invert step__icon-complete"
        src="assets/img/ui-commons/badge-check.svg"
        alt="Badge check"
        *ngIf="step.completed && currentStep !== $index + 1"
      />
      <span>
        <h3 class="font-medium leading-tight name-step name-step" [ngClass]="{ 'name-step--short': steps.length > 2 }">
          {{ step.title | translate }}
        </h3>
        <p class="text-sm">{{ step.subtitle | translate }}</p>
      </span>
    </li>
  }
</ol>
<div class="slide-container">
  <div id="templates-container" class="templates-container">
    @for (step of steps; track $index) {
      <ng-container [ngTemplateOutlet]="step.template"></ng-container>
    }
  </div>
</div>
